import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { actionCreators } from "../redux/productSalesSagas";
import MultiSelectDropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";

const PrimaryCategories = () => {
  const dispatch = useDispatch();

  const primaryCategories = useSelector((state) => state.productSales.filters.primary_categories);
  const selectedPrimaryCategories = useSelector(
    (state) => state.productSales.selectedFilters.primary_categories
  );

  return (
    <MultiSelectDropdown
      options={primaryCategories}
      selectedFilters={selectedPrimaryCategories}
      placeholder="Add/Remove Categories"
      numberDisplayed={0}
      includeSelectAll
      enableOnly
      height={324}
      onSelectChange={(data) => dispatch(actionCreators.updatePrimaryCategory(data))}
    />
  );
};

export default PrimaryCategories;
